export default __webpack_public_path__ + "static/media/wallet-connect.675385b0.svg";